import { api } from '../../components/common';
import { Phone, Email, ContactsAddressWithDetails, Contact, ContactWithDetails } from '../../crm/components/contacts/types';
import { Category } from '../../crm/components/category/types';

export interface PropertyResponse {
  data: any | null;
  message?: string;
}

export interface LeaseResponse {
  data: any | null;
  message?: string;
}

export interface ContactResponse {
  data: any;
}

export const residentApi = {
  getProperty: (): Promise<PropertyResponse> =>
    api.get('/resident/property').then(res => res.data),

  getLease: (): Promise<LeaseResponse> =>
    api.get('/resident/lease').then(res => res.data),

  getContact: (): Promise<ContactResponse> =>
    api.get('/resident/contact').then(res => res.data),

  getContacts: (): Promise<{ data: ContactWithDetails[] }> =>
    api.get('/resident/contacts').then(res => res.data),

  createContact: (contact: Omit<Contact, 'id' | 'dateCreated' | 'dateUpdated' | 'whoUpdated'>): Promise<{ data: Contact }> =>
    api.post('/resident/contacts', contact).then(res => res.data),

  updateContact: (id: number, contact: Partial<Contact>): Promise<{ data: Contact }> =>
    api.put(`/resident/contacts/${id}`, contact).then(res => res.data),

  deleteContact: (id: number): Promise<void> =>
    api.delete(`/resident/contacts/${id}`).then(() => {}),

  getPhones: (): Promise<{ data: Phone[] }> =>
    api.get('/resident/phones').then(res => res.data),

  createPhone: (phone: { typeId?: number; phoneNumber: string; isPrimary?: boolean }): Promise<{ data: Phone }> =>
    api.post('/resident/phones', phone).then(res => res.data),

  updatePhone: (id: number, phone: Partial<Phone>): Promise<{ data: Phone }> =>
    api.put(`/resident/phones/${id}`, phone).then(res => res.data),

  deletePhone: (id: number): Promise<void> =>
    api.delete(`/resident/phones/${id}`).then(() => {}),

  getEmails: (): Promise<{ data: Email[] }> =>
    api.get('/resident/emails').then(res => res.data),

  createEmail: (email: { typeId?: number; emailAddress: string; isPrimary?: boolean }): Promise<{ data: Email }> =>
    api.post('/resident/emails', email).then(res => res.data),

  updateEmail: (id: number, email: Partial<Email>): Promise<{ data: Email }> =>
    api.put(`/resident/emails/${id}`, email).then(res => res.data),

  deleteEmail: (id: number): Promise<void> =>
    api.delete(`/resident/emails/${id}`).then(() => {}),

  getAddresses: (): Promise<{ data: ContactsAddressWithDetails[] }> =>
    api.get('/resident/addresses').then(res => res.data),

  createAddress: (address: { typeId: number; address: any; description?: string; isPrimary?: boolean }): Promise<{ data: ContactsAddressWithDetails }> =>
    api.post('/resident/addresses', address).then(res => res.data),

  updateAddress: (id: number, address: any): Promise<{ data: ContactsAddressWithDetails }> =>
    api.put(`/resident/addresses/${id}`, address).then(res => res.data),

  deleteAddress: (id: number): Promise<void> =>
    api.delete(`/resident/addresses/${id}`).then(() => {}),

  getCategoriesByType: (type: string): Promise<{ data: Category[] }> =>
    api.get(`/resident/categories/${type}`).then(res => res.data),

  // Create phone for a specific contact
  createPhoneForContact: (contactId: number, phone: { typeId?: number; phoneNumber: string; isPrimary?: boolean }): Promise<{ data: Phone }> =>
    api.post(`/resident/contacts/${contactId}/phones`, phone).then(res => res.data),

  // Create email for a specific contact
  createEmailForContact: (contactId: number, email: { typeId?: number; emailAddress: string; isPrimary?: boolean }): Promise<{ data: Email }> =>
    api.post(`/resident/contacts/${contactId}/emails`, email).then(res => res.data),
};

